import React from 'react';
import { Box, Typography } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import FacebookIcon from '@mui/icons-material/Facebook';
import * as styles from './styles';

const SOCIAL_LINKS = [
    { label: 'Instagram', href: 'https://www.instagram.com/ecalworld', Icon: InstagramIcon },
    { label: 'X', href: 'https://x.com/ecalworld', Icon: XIcon },
    { label: 'Facebook', href: 'https://www.facebook.com/ECALworld/', Icon: FacebookIcon },
];

function SocialConnect() {
    return (
        <Box sx={styles.socialBlock}>
            <Typography sx={styles.colTitle}>Connect with us</Typography>
            <Box sx={styles.socialIconRow}>
                {SOCIAL_LINKS.map(({ label, href, Icon }) => (
                    <Box
                        key={label}
                        component="a"
                        href={href}
                        target="_blank"
                        rel="noreferrer noopener"
                        aria-label={`ECAL on ${label}`}
                        sx={styles.socialIcon}
                    >
                        <Icon fontSize="small" />
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export default SocialConnect;
